require("react");
require("react-dom");
require("react-redux");
require("react-router");
require("react-router-redux");
require("react-css-modules");
require("redux");
require("redux-observable");
require("redux-thunk");

require("rxjs");

// TODO move deps here from src/app/ files
// require("raven-for-redux")

import { ResponsiveContainer, AreaChart, XAxis, YAxis, Tooltip, Area } from "recharts";

require("classnames");
require("svg-inline-react");
require("semantic-ui-react");
require("lodash");
require("axios");

window.I18n = require("i18n/i18n");
require("i18n/translations");
require("i18n/config");
I18n.locale = "en";
I18n.availableLocales = Object.keys(I18n.translations);

window.moment = require("moment");
moment.locale(I18n.locale);
moment.RUBY_DATE_FORMAT = "YYYY-MM-DD";
moment.RUBY_DATETIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSSZ";
moment.RUBY_DATETIME_WITHOUT_TIMEZONE_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS";
moment.TIME_FORMAT = "HH:mm";
require("moment-timezone");
moment.tz.guess();

require("react-dnd");
require("react-dnd-html5-backend");
require("react-big-calendar");
require("react-big-calendar/lib/css/react-big-calendar.css");
require("react-big-calendar/lib/addons/dragAndDrop");

require("react-dates");
require("rc-time-picker");

require("quill");
require("quill/dist/quill.snow.css");
require("react-quill");

if (!__DEV__) {
  window.Raven = require("raven-js");
}

if (__DEV__) {
  require("webpack-hot-middleware/client");
  require("react-hot-loader/patch");
}



// WEBPACK FOOTER //
// ./src/vendor.js